// Module
var code = "<span class=\"select2-result-repository clearfix\"> <!-- ko text: RecipientName --><!-- /ko --> <!-- ko if: Email --> (<!-- ko text: Email --><!-- /ko -->) <!-- /ko --> <!-- ko ifnot: Email --> (<span data-bind=\"event: { mouseup: $data.AddEmail }\" class=\"show-popup\">click</span> to add the email) <!-- /ko --> </span>";
// Exports
export default code;